import { LazyAction, LazyModule } from 'owa-bundling';

export { default as displayAppointmentForm } from './utils/displayAppointmentForm';
export { getStore as getReadingPaneStore } from './store/store';
export { default as getReadEvent } from './selectors/getReadEvent';
export { default as getIsOnlineMeetingLocationRowExpanded } from './selectors/getIsOnlineMeetingLocationRowExpanded';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarReadingPaneStore"*/ './lazyIndex')
);

export let lazyOnReadingPaneScrolled = new LazyAction(lazyModule, m => m.onReadingPaneScrolled);
export let lazySetScrollToInsightsOnInitialRender = new LazyAction(
    lazyModule,
    m => m.setScrollToInsightsOnInitialRender
);
export let lazySetIsOnlineMeetingLocationRowExpanded = new LazyAction(
    lazyModule,
    m => m.setIsOnlineMeetingLocationRowExpanded
);
